// extracted by mini-css-extract-plugin
module.exports = {"card_footer":"RecoverPasswordFormEmail_card_footer__1Q_w5","card_content":"RecoverPasswordFormEmail_card_content__3mXBe"};